module.exports = "/img/datav.db71c1a1.png";